// import { useEffect, useState } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import axios from "../axiosInstance";

// const QRScan = () => {
//   const navigate = useNavigate();
//   const [params] = useSearchParams();

//   const sellerId = params.get("sellerId");
//   const buyerCategoryId = params.get("buyerCategoryId");

//   const [createConn, setCreateConn] = useState("");

//   // Save QR params
//   useEffect(() => {
//     if (sellerId && buyerCategoryId) {
//       localStorage.setItem(
//         "qrData",
//         JSON.stringify({ sellerId, buyerCategoryId })
//       );
//     }
//   }, [sellerId, buyerCategoryId]);

//   // Main flow
//   useEffect(() => {
//     const token = localStorage.getItem("token");

//     // Not logged in → register
//     if (!token) {
//       navigate("/register");
//       return;
//     }

//     // Logged in → get QR data
//     const qrData = JSON.parse(localStorage.getItem("qrData"));

//     if (qrData?.sellerId && qrData?.buyerCategoryId) {
//       const createConnection = async (token, qrData) => {
//         try {
//           const userRes = await axios.get("/api/v1/auth/profile", {
//             headers: { Authorization: `Bearer ${token}` },
//           });

//           const user = userRes.data.user;

//           const connectionRes = await axios.post(
//             "/api/v1/buyer-seller-connections/connection",
//             {
//               buyerCategory: qrData.buyerCategoryId,
//               buyerEmail: user.email || null,
//               buyerPhone: user.phone || null,
//               seller: qrData.sellerId,
//             },
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );

//           const connectionId = connectionRes.data.data._id;
//           setCreateConn(connectionId);

//           // Auto accept
//           await axios.put(
//             `/api/v1/buyer-seller-connections/connection/${connectionId}/status`,
//             { status: "Accepted" },
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );

//           // Cleanup QR data
//           localStorage.removeItem("qrData");

//           navigate("/buyer-dashboard/view-products", {
//             state: {
//               connectionId,
//               otherUserId: qrData.sellerId,
//             },
//           });
//         } catch (error) {
//           console.error("QR Scan Error:", error.response?.data || error.message);
//         }
//       };

//       createConnection(token, qrData);
//     }
//   }, [navigate]);

//   return (
//     <>
//       <p>QR scan processing...</p>
      
//     </>
//   );
// };

// export default QRScan;


// import { useEffect, useState } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import axios from "../axiosInstance";
// import {
//   CircularProgress,
//   Box,
//   Typography,
//   Container,
//   Paper,
//   Alert,
//   Button,
//   Stack
// } from "@mui/material";
// import {
//   QrCodeScanner,
//   CheckCircle,
//   Error,
//   ArrowForward,
//   PersonAdd
// } from "@mui/icons-material";

// const QRScan = () => {
//   const navigate = useNavigate();
//   const [params] = useSearchParams();

//   const sellerId = params.get("sellerId");
//   const buyerCategoryId = params.get("buyerCategoryId");

//   const [status, setStatus] = useState("processing"); // processing, redirecting, success, error
//   const [errorMessage, setErrorMessage] = useState("");
//   const [createConn, setCreateConn] = useState("");

//   // Save QR params
//   useEffect(() => {
//     if (sellerId && buyerCategoryId) {
//       localStorage.setItem(
//         "qrData",
//         JSON.stringify({ sellerId, buyerCategoryId })
//       );
//     }
//   }, [sellerId, buyerCategoryId]);

//   // Main flow
//   useEffect(() => {
//     const token = localStorage.getItem("token");

//     // Not logged in → redirect to register with state
//     if (!token) {
//       setStatus("redirecting");
      
//       // Save current URL to redirect back after registration
//       const currentPath = window.location.pathname + window.location.search;
//       localStorage.setItem("redirectAfterLogin", currentPath);
      
//       // Navigate to register page
//       setTimeout(() => {
//         navigate("/register", { 
//           state: { 
//             fromQR: true,
//             qrData: { sellerId, buyerCategoryId }
//           }
//         });
//       }, 1500);
//       return;
//     }

//     // Logged in → process QR data
//     const processQRData = async () => {
//       try {
//         const qrData = JSON.parse(localStorage.getItem("qrData"));

//         if (!qrData?.sellerId || !qrData?.buyerCategoryId) {
//           setStatus("error");
//           setErrorMessage("Invalid QR code data. Please scan a valid QR code.");
//           return;
//         }

//         // Get user profile
//         const userRes = await axios.get("/api/v1/auth/profile", {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const user = userRes.data.user;

//         // Create connection
//         const connectionRes = await axios.post(
//           "/api/v1/buyer-seller-connections/connection",
//           {
//             buyerCategory: qrData.buyerCategoryId,
//             buyerEmail: user.email || null,
//             buyerPhone: user.phone || null,
//             seller: qrData.sellerId,
//           },
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         const connectionId = connectionRes.data.data._id;
//         setCreateConn(connectionId);

//         // Auto accept the connection
//         await axios.put(
//           `/api/v1/buyer-seller-connections/connection/${connectionId}/status`,
//           { status: "Accepted" },
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         // Cleanup
//         localStorage.removeItem("qrData");
//         localStorage.removeItem("redirectAfterLogin");

//         setStatus("success");
        
//         // Navigate to products after short delay
//         setTimeout(() => {
//           navigate("/buyer-dashboard/view-products", {
//             state: {
//               connectionId,
//               otherUserId: qrData.sellerId,
//               fromQR: true
//             },
//             replace: true
//           });
//         }, 2000);

//       } catch (error) {
//         console.error("QR Scan Error:", error.response?.data || error.message);
//         setStatus("error");
        
//         if (error.response?.status === 409) {
//           setErrorMessage("Connection already exists with this seller.");
//         } else if (error.response?.status === 404) {
//           setErrorMessage("Seller or buyer category not found.");
//         } else {
//           setErrorMessage("Failed to process QR code. Please try again.");
//         }
//       }
//     };

//     if (token && (sellerId || localStorage.getItem("qrData"))) {
//       processQRData();
//     }
//   }, [navigate, sellerId, buyerCategoryId]);

//   const handleManualRedirect = () => {
//     if (status === "redirecting") {
//       navigate("/register", { 
//         state: { 
//           fromQR: true,
//           qrData: { sellerId, buyerCategoryId }
//         }
//       });
//     } else if (status === "error") {
//       // Try again
//       window.location.reload();
//     }
//   };

//   const renderContent = () => {
//     switch (status) {
//       case "processing":
//         return (
//           <>
//             <CircularProgress size={60} thickness={4} sx={{ color: "#0b4064", mb: 3 }} />
//             <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
//               Processing QR Code
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               Setting up your connection with the seller...
//             </Typography>
//           </>
//         );

//       case "redirecting":
//         return (
//           <>
//             <PersonAdd sx={{ fontSize: 60, color: "#1976d2", mb: 3 }} />
//             <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
//               Account Required
//             </Typography>
//             <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
//               You need an account to connect with this seller. Redirecting to registration...
//             </Typography>
//             <Button
//               variant="contained"
//               size="large"
//               endIcon={<ArrowForward />}
//               onClick={handleManualRedirect}
//               sx={{
//                 bgcolor: "#1976d2",
//                 "&:hover": { bgcolor: "#1565c0" },
//                 px: 4,
//                 py: 1.5
//               }}
//             >
//               Go to Registration
//             </Button>
//           </>
//         );

//       case "success":
//         return (
//           <>
//             <CheckCircle sx={{ fontSize: 60, color: "#2e7d32", mb: 3 }} />
//             <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
//               Connection Successful!
//             </Typography>
//             <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
//               You are now connected with the seller.
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Redirecting to products...
//             </Typography>
//             <CircularProgress size={24} sx={{ color: "#2e7d32", mt: 3 }} />
//           </>
//         );

//       case "error":
//         return (
//           <>
//             <Error sx={{ fontSize: 60, color: "#d32f2f", mb: 3 }} />
//             <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
//               Connection Failed
//             </Typography>
//             <Alert severity="error" sx={{ mb: 3, maxWidth: 400 }}>
//               {errorMessage}
//             </Alert>
//             <Stack direction="row" spacing={2}>
//               <Button
//                 variant="contained"
//                 onClick={handleManualRedirect}
//                 sx={{ bgcolor: "#d32f2f", "&:hover": { bgcolor: "#c62828" } }}
//               >
//                 Try Again
//               </Button>
//               <Button
//                 variant="outlined"
//                 onClick={() => navigate("/")}
//               >
//                 Go Home
//               </Button>
//             </Stack>
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <Container maxWidth="sm">
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           py: 4
//         }}
//       >
//         <Paper
//           elevation={3}
//           sx={{
//             p: { xs: 3, sm: 4 },
//             width: "100%",
//             textAlign: "center",
//             borderRadius: 3,
//             background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
//           }}
//         >
//           {/* Header */}
//           <Box sx={{ mb: 4 }}>
//             <QrCodeScanner sx={{ fontSize: 48, color: "#0b4064", mb: 2 }} />
//             <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: "#1a365d" }}>
//               QR Code Scanner
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               {status === "processing" && "Setting up your seller connection..."}
//               {status === "redirecting" && "Account setup required for connection"}
//               {status === "success" && "Successfully connected with seller"}
//               {status === "error" && "Unable to process QR code"}
//             </Typography>
//           </Box>

//           {/* Main Content */}
//           <Box sx={{ my: 5 }}>
//             {renderContent()}
//           </Box>

//           {/* Connection Details */}
//           {(sellerId || createConn) && (
//             <Box
//               sx={{
//                 mt: 4,
//                 pt: 3,
//                 borderTop: 1,
//                 borderColor: "divider",
//                 textAlign: "left"
//               }}
//             >
//               <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                 Connection Details
//               </Typography>
//               <Stack spacing={1}>
//                 {sellerId && (
//                   <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
//                     Seller ID: {sellerId}
//                   </Typography>
//                 )}
//                 {buyerCategoryId && (
//                   <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
//                     Category ID: {buyerCategoryId}
//                   </Typography>
//                 )}
//                 {createConn && (
//                   <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
//                     Connection ID: {createConn}
//                   </Typography>
//                 )}
//               </Stack>
//             </Box>
//           )}

//           {/* Debug Info (optional - can be removed in production) */}
//           {process.env.NODE_ENV === "development" && (
//             <Box sx={{ mt: 4, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
//               <Typography variant="caption" color="text.secondary">
//                 Status: {status} | Has Token: {!!localStorage.getItem("token")}
//               </Typography>
//             </Box>
//           )}
//         </Paper>
//       </Box>
//     </Container>
//   );
// };

// export default QRScan

import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "../axiosInstance";
import {
  CircularProgress,
  Box,
  Typography,
  Container,
  Paper,
  Alert,
  Button,
  Stack
} from "@mui/material";
import {
  QrCodeScanner,
  CheckCircle,
  Error,
  ArrowForward,
  PersonAdd,
  Login
} from "@mui/icons-material";

const QRScan = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const sellerId = params.get("sellerId");
  const buyerCategoryId = params.get("buyerCategoryId");

  const [status, setStatus] = useState("checking"); // checking, processing, login_required, success, error
  const [errorMessage, setErrorMessage] = useState("");
  const [createConn, setCreateConn] = useState("");
  const [qrData, setQrData] = useState(null);

  // Initialize QR data
  useEffect(() => {
    if (sellerId && buyerCategoryId) {
      const data = { sellerId, buyerCategoryId };
      setQrData(data);
      localStorage.setItem("qrData", JSON.stringify(data));
    } else {
      // Check if QR data exists in localStorage
      const storedData = localStorage.getItem("qrData");
      if (storedData) {
        setQrData(JSON.parse(storedData));
      }
    }
  }, [sellerId, buyerCategoryId]);

  // Main flow - runs only after user action
  useEffect(() => {
    if (status === "processing") {
      processQRConnection();
    }
  }, [status]);

  const processQRConnection = async () => {
    const token = localStorage.getItem("token");
    
    if (!token) {
      setStatus("login_required");
      return;
    }

    try {
      if (!qrData?.sellerId || !qrData?.buyerCategoryId) {
        setStatus("error");
        setErrorMessage("Invalid QR code data. Please scan a valid QR code.");
        return;
      }

      // Get user profile
      const userRes = await axios.get("/api/v1/auth/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = userRes.data.user;

      // Create connection
      const connectionRes = await axios.post(
        "/api/v1/buyer-seller-connections/connection",
        {
          buyerCategory: qrData.buyerCategoryId,
          buyerEmail: user.email || null,
          buyerPhone: user.phone || null,
          seller: qrData.sellerId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const connectionId = connectionRes.data.data._id;
      setCreateConn(connectionId);

      // Auto accept the connection
      await axios.put(
        `/api/v1/buyer-seller-connections/connection/${connectionId}/status`,
        { status: "Accepted" },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Cleanup
      localStorage.removeItem("qrData");
      localStorage.removeItem("redirectAfterLogin");

      setStatus("success");
      
      // Navigate to products after short delay
      setTimeout(() => {
        navigate("/buyer-dashboard/view-products", {
          state: {
            connectionId,
            otherUserId: qrData.sellerId,
            fromQR: true
          },
          replace: true
        });
      }, 2000);

    } catch (error) {
      console.error("QR Scan Error:", error.response?.data || error.message);
      setStatus("error");
      
      if (error.response?.status === 409) {
        setErrorMessage("You are already connected with this seller.");
        
        // If already connected, redirect to products
        setTimeout(() => {
          navigate("/buyer-dashboard/view-products", {
            replace: true
          });
        }, 3000);
      } else if (error.response?.status === 404) {
        setErrorMessage("Seller or buyer category not found.");
      } else if (error.response?.status === 401) {
        setErrorMessage("Session expired. Please login again.");
        setStatus("login_required");
      } else {
        setErrorMessage("Failed to process QR code. Please try again.");
      }
    }
  };

  const handleStartProcess = () => {
    setStatus("processing");
  };

  const handleLoginRedirect = () => {
    // Save current URL for redirect after login
    const currentPath = window.location.pathname + window.location.search;
    localStorage.setItem("redirectAfterLogin", currentPath);
    
    navigate("/login", { 
      state: { 
        fromQR: true,
        qrData: qrData
      }
    });
  };

  const handleRegisterRedirect = () => {
    // Save current URL for redirect after registration
    const currentPath = window.location.pathname + window.location.search;
    localStorage.setItem("redirectAfterLogin", currentPath);
    
    navigate("/register", { 
      state: { 
        fromQR: true,
        qrData: qrData
      }
    });
  };

  const handleManualRedirect = () => {
    if (status === "error") {
      // Try again
      window.location.reload();
    }
  };

  const renderContent = () => {
    switch (status) {
      case "checking":
        return (
          <>
            <QrCodeScanner sx={{ fontSize: 60, color: "#0b4064", mb: 3 }} />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              QR Code Detected
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
              You have scanned a seller's QR code. Connect with this seller to browse their products.
            </Typography>
            
            {qrData ? (
              <Stack spacing={2}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleStartProcess}
                  sx={{
                    bgcolor: "#0b4064",
                    "&:hover": { bgcolor: "#093358" },
                    px: 4,
                    py: 1.5
                  }}
                >
                  Connect with Seller
                </Button>
                <Typography variant="body2" color="text.secondary">
                  You need to be logged in to continue
                </Typography>
              </Stack>
            ) : (
              <Alert severity="warning" sx={{ mb: 3 }}>
                No valid QR data found. Please scan a valid QR code.
              </Alert>
            )}
          </>
        );

      case "processing":
        return (
          <>
            <CircularProgress size={60} thickness={4} sx={{ color: "#0b4064", mb: 3 }} />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Processing Connection
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Setting up your connection with the seller...
            </Typography>
          </>
        );

      case "login_required":
        return (
          <>
            <Login sx={{ fontSize: 60, color: "#1976d2", mb: 3 }} />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Login Required
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
              You need to login or create an account to connect with this seller.
            </Typography>
            <Stack spacing={2} sx={{ maxWidth: 300, mx: "auto" }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleLoginRedirect}
                startIcon={<Login />}
                sx={{
                  bgcolor: "#1976d2",
                  "&:hover": { bgcolor: "#1565c0" },
                  py: 1.5
                }}
              >
                Login to Continue
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={handleRegisterRedirect}
                startIcon={<PersonAdd />}
                sx={{ py: 1.5 }}
              >
                Create New Account
              </Button>
            </Stack>
          </>
        );

      case "success":
        return (
          <>
            <CheckCircle sx={{ fontSize: 60, color: "#2e7d32", mb: 3 }} />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Connection Successful!
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              You are now connected with the seller.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Redirecting to products...
            </Typography>
            <CircularProgress size={24} sx={{ color: "#2e7d32", mt: 3 }} />
          </>
        );

      case "error":
        return (
          <>
            <Error sx={{ fontSize: 60, color: "#d32f2f", mb: 3 }} />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Connection Failed
            </Typography>
            <Alert severity="error" sx={{ mb: 3, maxWidth: 400 }}>
              {errorMessage}
            </Alert>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                onClick={handleManualRedirect}
                sx={{ bgcolor: "#d32f2f", "&:hover": { bgcolor: "#c62828" } }}
              >
                Try Again
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate("/")}
              >
                Go Home
              </Button>
            </Stack>
          </>
        );

      default:
        return null;
    }
  };

  // Auto-check on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedData = localStorage.getItem("qrData");
    
    if (storedData) {
      setQrData(JSON.parse(storedData));
      
      if (!token) {
        // If no token but has QR data, show login/register options
        setStatus("login_required");
      } else {
        // If has token, check if user wants to auto-process
        setStatus("checking");
      }
    } else if (sellerId && buyerCategoryId) {
      // If URL has params but no localStorage data
      const data = { sellerId, buyerCategoryId };
      setQrData(data);
      localStorage.setItem("qrData", JSON.stringify(data));
      
      if (!token) {
        setStatus("login_required");
      } else {
        setStatus("checking");
      }
    } else {
      // No QR data at all
      setStatus("error");
      setErrorMessage("No QR code data found. Please scan a valid QR code.");
    }
  }, []);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 4 },
            width: "100%",
            textAlign: "center",
            borderRadius: 3,
            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
          }}
        >
          {/* Header */}
          <Box sx={{ mb: 4 }}>
            <QrCodeScanner sx={{ fontSize: 48, color: "#0b4064", mb: 2 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: "#1a365d" }}>
              QR Code Connection
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {status === "checking" && "Ready to connect with seller"}
              {status === "processing" && "Setting up your seller connection..."}
              {status === "login_required" && "Account required for connection"}
              {status === "success" && "Successfully connected with seller"}
              {status === "error" && "Unable to process QR code"}
            </Typography>
          </Box>

          {/* Main Content */}
          <Box sx={{ my: 5 }}>
            {renderContent()}
          </Box>

          {/* Connection Details (Only show in checking state) */}
          {qrData && status === "checking" && (
            <Box
              sx={{
                mt: 4,
                pt: 3,
                borderTop: 1,
                borderColor: "divider",
                textAlign: "left"
              }}
            >
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Connection Details
              </Typography>
              <Stack spacing={1}>
                {qrData.sellerId && (
                  <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: "0.8rem" }}>
                    Seller ID: {qrData.sellerId}
                  </Typography>
                )}
                {qrData.buyerCategoryId && (
                  <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: "0.8rem" }}>
                    Category ID: {qrData.buyerCategoryId}
                  </Typography>
                )}
              </Stack>
            </Box>
          )}

          {/* Debug Info (optional - can be removed in production) */}
          {process.env.NODE_ENV === "development" && (
            <Box sx={{ mt: 4, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Status: {status} | Has Token: {!!localStorage.getItem("token")}
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default QRScan;